import { motion } from "framer-motion";
import CountdownTimer from "./CountdownTimer";

// Set event date to 2 weeks from now for demo
const getEventDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 14);
  date.setHours(10, 0, 0, 0);
  return date.toISOString();
};

{
  /* Countdown Timer */
}
const CountingDown = () => {
  return (
    <section
      className="section-wrapper relative min-h-3/2 flex flex-col items-center justify-center px-4 sm:px-6 py-16 sm:py-20 overflow-hidden bg-white/50"
      data-testid="counting-section"
    >
      <div className="relative z-10 text-center max-w-3xl mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1.1 }}
        >
          <p className="font-serif-accent text-[10px] sm:text-xs tracking-[0.15em] sm:tracking-[0.2em] text-[#D4AF37] uppercase mb-4 sm:mb-6">
            Counting Down
          </p>
          <CountdownTimer targetDate={getEventDate()} />
        </motion.div>
      </div>
    </section>
  );
};

export default CountingDown;
